import React, { useEffect } from 'react';
import propTypes from 'prop-types';
import axios from 'axios';
import ComponentContainer from 'tailwind-components/ComponentContainer/ComponentContainer';
import ProfileApptBanner from './ProfileApptBanner';
import AnnouncementsCarousel from 'tailwind-components/AnnouncementsCarousel/AnnouncementsCarousel';
import CalendarSection from './CalendarSection/CalendarSection';
import ContentWithSidebar from 'tailwind-components/ContentWithSidebar/ContentWithSidebar';
import ProfileCharts from './ProfileCharts';
import AgentOwnerCard from 'tailwind-components/Sidebar/AgentOwnerCard';
import { areAnnouncementsHidden } from 'helpers/viewing-rules';
import { getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();
const isOneill = company === 'oneill';

export default function Dashboard({
  user,
  announcements,
  importantDates,
  calendarEvents,
  getDashboardData
}) {
  const hideAnnouncements = areAnnouncementsHidden(user?.agencyData);

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();
    getDashboardData(cancelTokenSource);
    return () => {
      cancelTokenSource.cancel('API Call Canceled');
    };
  }, [user?.id, getDashboardData]);

  return (
    <ComponentContainer className='h-auto lg:h-full'>
      <ProfileApptBanner user={user} />
      {isOneill && <ProfileCharts user={user} />}
      <ContentWithSidebar
        reverseMobile
        disableScrollOverflow
        mainContent={
          <CalendarSection
            importantDates={importantDates}
            calendarEvents={calendarEvents}
          />
        }
        sidebarContent={
          <div className='flex min-w-0 flex-col gap-4'>
            {!hideAnnouncements && (
              <AnnouncementsCarousel data={announcements ?? []} timer={6000} />
            )}
            {isOneill && (
              <AgentOwnerCard className='rounded-xl md:shadow-sm bg-white' />
            )}
          </div>
        }
      />
    </ComponentContainer>
  );
}

Dashboard.propTypes = {
  getDashboardData: propTypes.func,
  announcements: propTypes.array,
  importantDates: propTypes.array,
  user: propTypes.object.isRequired,
  calendarEvents: propTypes.array
};
